var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLineVersionLogoPaper(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    contentScriptType: "text/ecmascript",
    width: 24,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    zoomAndPan: "magnify",
    contentStyleType: "text/css",
    viewBox: "0 0 24 24",
    height: 24,
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10,
    stroke: "#3e3832",
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 3.5h11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 6.5h5v6h-5zM11.5 8.5h3M10.5 10.5h4M10.5 12.5h4M3.5 14.5h11M3.5 16.5h11M3.5 18.5h11M19.5 5.5h2v15c0 .553-.447 1-1 1-.552 0-1-.447-1-1v-18.5h-2v2M20.5 23.5h-17c-1.656 0-3-1.344-3-3v-20h17v20c0 1.656 1.344 3 3 3 1.657 0 3-1.344 3-3v-17h-4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineVersionLogoPaper);
export default __webpack_public_path__ + "static/media/line-version-logo-paper.1cb3a24bc95dcb3f092aa90effb1b44b.svg";
export { ForwardRef as ReactComponent };